import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/suse': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M471.1 102.7c0-1 1-0.8 0.9-0.7 4.2 0.6 92.2 13.7 129.2 35.3 12.1 6.9 20.7 21.5 34.5 69.6 0.7 2.8-2.8 5.1-3.6 5.7-26.9 18.8-56.8 36.6-145.2-21.7 11.1 26.7 10.7 25.1 11 25.5 5.4 2.8 56.3 28.7 81.6 28.2 20.4-0.4 42.2-10.4 50.9-15.6 0 0 4.5-2.7 3.2 2.4-0.5 1.9-3.3 14.6-7 17.7-1 1-36.6 28.4-103.1 28-42.7-1-76.8-16.4-82.4 17.4-2.8 17.1 6.1 37.5 18.9 55.8h-48.6c-15.9-28.4-23.1-68.3-79.8-68.3-51.6 0-48.4 50.7-42.7 68.3h-45.9c-18.8-68.8-69.2-98.6-102.4-104.3-74.3-12.8-113 49.2-87 98.4 23.1 43.6 81.4 44.1 99.7 20.4 19.2-25 3.8-62.9-28.5-65.7-12.3-1.1-25.3 4.6-25.5 16.9v0.1c0 10.9 10 13.8 12 14 7.3-0.4 8.9-1.9 11.8-2.4 5.2-0.9 16.8 1.8 16.8 13.9 0 8.4-6.8 13.1-13.3 14.9-4.2 1.5-11.3 2.7-15.8 2.7-17.2 0-41.2-14.8-41.5-42.6-0.2-15.7 7.7-30 21.6-39.2 15.9-10.5 43.6-14.1 69.2 1.6 31.5 19.3 39.7 57.1 31.5 82.9-11.9 37.3-45.6 57.2-90 53.3-31.5-2.8-60.7-19.4-78.1-44.4-6.3-9-13.7-25-16.5-35.7-7.1-28.1 0-58.1 5.5-71.4 25.7-63.6 80.2-97.3 99.6-109.7 100.2-61.6 171.1-59.1 223-57.3 61.3 2.2 126.6 23.3 135.7 26.3 0-2 0.3-20.3 0.3-20.3zM531.5 175.5c-1.1 33.5 39.1 51.6 63.3 28.9 24.4-22.9 9-64-24.4-65.2-0.4 0-1 0-1.4 0-20.1 0-36.9 16.3-37.5 36.3zM570.1 150.2c14 0.4 25.4 12.1 25.4 26.2 0 0.3 0 0.7 0 1-0.5 14-12.3 25.3-26.3 25.3-14.5 0-26.3-11.8-26.3-26.3s11.8-26.3 26.3-26.3c0.2 0 0.6 0 0.9 0zM574.4 179c15.4 0 15.4-15.6 0-15.6-15.4 0-15.4 15.6 0 15.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/suse.js
// module id = 1044
// module chunks = 0